
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lpec/[slug]",
      function () {
        return require("private-next-pages/lpec/[slug].tsx");
      }
    ]);
  